import { useAction, useAtom } from '@reatom/npm-react'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

import {
  openBuyBoostersFlowEvent,
  openBuyPremiumFlowEvent,
} from '@root/entities/premium'
import {
  CheckCurrencyActions,
  type CheckCurrencyReatom,
} from '@root/features/premium'
import { useTranslation } from '@root/shared/localization'
import { PremiumDialog } from '@root/shared/ui/premium-dialog'

import { CheckCurrencyDialogContent } from './check-currency-dialog-content'

type Props = {
  model: CheckCurrencyReatom
}

export const CheckCurrencyDialog: React.FC<Props> = ({ model }) => {
  const { t } = useTranslation()

  const [open, setOpen] = useState(false)
  const [state] = useAtom(model.checkCurrencyStateAtom)
  const openBuyPremiumDrawer = useAction(openBuyPremiumFlowEvent)
  const openBuyBoostersDrawer = useAction(openBuyBoostersFlowEvent)

  useEffect(() => {
    if (state.value) {
      setOpen(true)
    }
  }, [state.value])

  return (
    <Root
      open={open}
      onOpenChange={setOpen}
      describedBy={t('premium.check.result')}
      title={t('premium.check.result')}
      onClose={() => setOpen(false)}
    >
      <Body>
        <CheckCurrencyDialogContent model={model} />
        <Actions
          onBuyBoosters={() =>
            state.value && state.value.premiumInfo
              ? openBuyBoostersDrawer({
                  currency: state.value.currency,
                  premium: state.value.premiumInfo,
                  shouldCheckSafety: false,
                })
              : undefined
          }
          onBuySubscription={() =>
            state.value
              ? openBuyPremiumDrawer({
                  currency: state.value.currency,
                  premium: state.value.premiumInfo,
                  shouldCheckSafety: false,
                })
              : undefined
          }
          result={state.value}
        />
      </Body>
    </Root>
  )
}

const Root = styled(PremiumDialog)`
  grid-template-rows: auto 1fr auto;
  width: 400px;
`

const Body = styled.div`
  padding: 24px 16px;
`

const Actions = styled(CheckCurrencyActions)`
  padding: 0;
  margin-top: 22px;
`
